import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-customeractivation',
  templateUrl: './customer-activation.component.html',
  styleUrls: ['./adminsubpartner.component.css']
})
export class CustomerActivationComponent implements OnInit {

  permision : string[] = [];
  currentuser : any = {};
  allowed = true;
  flagging:any = {};

  ViewCustomer: any = [];
  ViewCustomeratvorder: any = [];
  Viewless: any = [];
  actionHistory: any = [];
  mylistservices: any = [];
  listlogservices: any = [];
  listlogprepaidinvoice: any = [];
  liststb: any = [];
  liststbcust: any = [];
  userinfo : [];
  Billing: any = [];
  itemchange: any = {};

  btnchange = false;
  showuserinfo = false;
  openInfoUser = false;
  alert_success = false;
  alert_failed = false;

  ListCustomer : any;
  ListServices : any;

  showin = true;

  alert_act='';

  formCust = this.fb.group({
    nama: [''],
    nik: [''],
    tlp: [''],
    tlp2: [''],
    email: [''],
    email2: [''],
    alamat: [''],
    kota: [''],
    partnername: [''],
    notes: [''],

  })
 
  formActivation = this.fb.group({
    customerid: [''],
    subpartnerid: [''],
    partnerid: [''],
    email: [''],
    token: ['',[Validators.required]],

  })

  formRepairing = this.fb.group({
    customerid: [''],
    subpartnerid: [''],
    partnerid: [''],
    email: [''],
    token: ['',[Validators.required]],

  })

  SelectedItem : any = [];
 
 subservices:any = [];
 table_data = false;
 table_load = false;

  paging :any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  customerid : number;

  constructor(
	  private route: ActivatedRoute,
	  private router: Router,
    public LoadJsOrder: LoadJsService,
    private fb: FormBuilder,
	  public partnerService: ApiPartnerService,
    private Auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.permision = this.currentuser.permision;
  	this.loadStart();
    this.setflag('atvinfo','open',true);
  }

  loadStart() {
    this.customerid = parseInt(this.route.snapshot.paramMap.get('id'));
    //alert(id);
    this.loadBilling();
  	this.loadCustomer(this.customerid);
    this.loadCustomers('?customersts=10');
    //this.loadsubLayanan(id);
    //this.loadServiceHistory(id);
    //this.loadPrepaidInvoiceHistory(id);
    this.loadCustomerATVORDER(this.customerid);
    this.checkbillingtype();
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.service.productname + '\n';
      });
      //console.log(item.services);

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }

  loadCustomers(queryParams: any)
  {
    this.table_data = false
    this.table_load = true
    return this.partnerService.GetSubPartnerCustomers(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        this.ListServices = output.data.services;
        //console.log(output);
        this.table_load = false
        this.table_data = true
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }

  loadsubLayanan(id)
  {
    return this.partnerService.GetSubServiceCustomer('?id='+id).subscribe((output: any) => {
      // console.log(output);
      this.subservices = output.data;
      
    });
  }

  viewdataorder(datatype,val){

    if ( this.ViewCustomeratvorder[datatype] == undefined ){
      return '--';
    }else{
      return this.ViewCustomeratvorder[datatype][val];
    }

  }

  onActionClick(act:any, item: any)
  {
    // console.log(item);
    this.alert_act = act;

    if ( act == "update") {
      console.log(item)
      this.loadLess(item)
    }
    else if ( act == "changebilling" ) {
      
      this.showin = true

      this.formActivation.get('email').setValue(item.nama)
      //this.formActivation.get('id').setValue(item.id)
      this.formActivation.get('token').setValue(item.billingtype)
      //this.formActivation.get('notes').setValue('')
      
    }
  }

  btntoggle(){
    this.showin = false
  }

  checkbillingtype(){
    if(this.ViewCustomer.billingtype == 1){
      return true
    }else{
      return false
    }
  }

  loadBilling() {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      this.Billing = output.data;
    })
  }

  loadCustomer(id: any) {
    this.setflag('view','loading',true);
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
      if ( output.status == true ){ 
        this.setflag('view','allowed',true);
        this.ViewCustomer = output.data;
        this.mylistservices = output.data.services;
        this.liststb = output.data.stb;
        this.liststbcust = output.data.stbcust;
        this.actionHistory = output.data.actionHistory;
        this.loadServices(id);

        this.formActivation.get('email').setValue(this.ViewCustomer.email);
        this.formActivation.get('customerid').setValue(this.ViewCustomer.id)
        this.formActivation.get('partnerid').setValue(this.ViewCustomer.partnerid)
        this.formActivation.get('subpartnerid').setValue(this.ViewCustomer.subpartnerid)

        this.formRepairing.get('email').setValue(this.ViewCustomer.email);
        this.formRepairing.get('customerid').setValue(this.ViewCustomer.id)
        this.formRepairing.get('partnerid').setValue(this.ViewCustomer.partnerid)
        this.formRepairing.get('subpartnerid').setValue(this.ViewCustomer.subpartnerid)

      }else{
        this.setflag('view','allowed',false);
      }
       this.setflag('view','loading',false);
    })
  }

  loadServices(id: any){
    
    this.partnerService.GetCustomerService('?id='+id).subscribe((output: any) => {
      //console.log(output);
      this.mylistservices = output.data;
    })
  }

  loadCustomerATVORDER(id: any) {
   // this.setflag('view','loading',true);
    return this.partnerService.GetViewCustomeratvorder(id).subscribe((output: any) => {
      if ( output.status == true ){ 
        this.ViewCustomeratvorder = output.data;
      }
     // this.setflag('view','loading',false);
    })
  }


  loadServiceHistory(id) {
    return this.partnerService.GetServiceHistory(id).subscribe((output: any) => {
      console.log(output);
       this.listlogservices = output.data;
    })
  }

  loadPrepaidInvoiceHistory(id) {
    return this.partnerService.GetPrepaidinvoiceHistory(id).subscribe((output: any) => {
      console.log(output);
       this.listlogprepaidinvoice = output.data;
    })
  }


  loadLess(item: any) {
    return this.partnerService.GetViewless(item.id).subscribe((output: any) => {
    console.log(output);
       this.Viewless = output.data;

       this.formCust.setValue(this.Viewless);

    })
  }

  rowSelected(item){
    this.SelectedItem = item;
  }

  openATVORDER(){
    this.setflag('atvorder','open',true);
    this.setflag('atvinfo','open',false);
    this.setflag('atvactive','open',false);
  }

  openATVACTIVE(){
    this.setflag('atvactive','open',true);
    this.setflag('atvinfo','open',false);
    this.setflag('atvorder','open',false);
  }
  openATVINFO(){
    this.setflag('atvinfo','open',true);
    this.setflag('atvorder','open',false);
    this.setflag('atvactive','open',false);
  }

  submitActivation(item: any) {

    this.setflag('submit','loading',true);
    this.setflag('activation','message','');
    this.setflag('submit','error',false);
    //console.log(this.formActivation.value);
    //return;
    return this.partnerService.PostActivationApps(this.formActivation.value).subscribe((output: any) => {
      if ( output.status ){
        
        this.setflag('submit','loading',false);
        this.setflag('submit','success',true);
        this.loadCustomer(this.customerid);
       

      } else {
        this.setflag('submit','loading',false);
        this.setflag('submit','error',true);
        
        this.setflag('activation','message',output.message);
        
       
      }      
    
    })
  }

  submitRepairing(item: any) {

    this.setflag('resubmit','loading',true);
    this.setflag('repairing','message','');
    this.setflag('resubmit','error',false);
    //console.log(this.formActivation.value);
    //return;
    return this.partnerService.PostRepairingApps(this.formRepairing.value).subscribe((output: any) => {
      if ( output.status ){
        
        this.setflag('resubmit','loading',false);
        this.setflag('resubmit','success',true);
        this.loadCustomer(this.customerid);
       

      } else {
        this.setflag('resubmit','loading',false);
        this.setflag('resubmit','error',true);
        
        this.setflag('repairing','message',output.message);
        
       
      }      
    
    })
  }


  Showatvuserid()
  {
    this.openInfoUser  = false;
    return this.partnerService.ATVShowUserId({sn:this.liststb.sn}).subscribe((output: any) => {
      console.log(output); 
      this.showuserinfo  = true;
      this.openInfoUser  = true;

      if (output.data == null){
        this.userinfo = [];

      }else{
        this.userinfo = output.data[0];

      }
       console.log(this.userinfo);  
    })
  }

  showuser(x)
  {
    if ( this.userinfo == undefined ){
      return '';
    } else {
      if (this.userinfo[x] == undefined){
        return '';
      }else{
        return this.userinfo[x];
      }
    }
  }

  MyPermission(p)
  {
    if ( this.permision == undefined ){
      return false;
    }

    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }
  }

  setflag(id,key,val)
  {
    console.log(id,key,val);
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if ( this.flagging[id][key] == undefined){
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    console.log(this.flagging[id]);
  }

  flag(id,key){
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    }else if (this.flagging[id][key] == undefined ) {
      this.flagging[id][key] = false;
    }

//    console.log(this.flagging[id]);
//    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

}
